import { Box, Button } from "@mui/material";
import { Participant } from "@zoom/videosdk";
import StyledDialog from "../../../components/StyledDialog";
import { DisclosureHost } from "../../../hooks/use-disclosure";
import Flex from "../../../components/Flex";
import Text from "../../../components/Text";

interface PatientJoinConfirmationProps {
  disclosureHost: DisclosureHost;
  onConfirm: () => void;
  incomingPatient: Participant[];
}

export const PatientJoinConfirmation = ({
  disclosureHost,
  onConfirm,
  incomingPatient,
}: PatientJoinConfirmationProps) => {
  return (
    <StyledDialog
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
      dialogTitle="Patient wants to join this call"
      dialogAction={
        <Flex gap={1}>
          <Button variant="text" onClick={disclosureHost.close} autoFocus>
            Deny
          </Button>
          <Button variant="contained" onClick={onConfirm} autoFocus>
            Admit
          </Button>
        </Flex>
      }
    >
      <Box width={"20vw"} height={"1vh"}>
        <Text>
          {`${incomingPatient?.[0]?.userIdentity ?? ""} is in waiting Room.`}
        </Text>
      </Box>
    </StyledDialog>
  );
};
